import { AxiosInstance } from 'axios';
import { createContext, ReactNode, useContext } from 'react';
//import { useConfig } from './config-provider';
//import useAxiosLoader from '../common/hooks/useAxiosLoader';
import useServiceClients from '../common/hooks/useServiceClients'; 
import { splunk_message } from '../common/splunk_constant';
import useSplunkLogger from '../common/hooks/useSplunkLogger';


const GQLContext = createContext<{ client: AxiosInstance } | null>(null);

type QueryOptions = {
  variables: any;
};

export const useQuery = (query: string) => {
  const ctx = useContext(GQLContext);
  const { splunkLogger } = useSplunkLogger();
  if (!ctx) throw new Error('GQLContext undefined!');
  const postQuery = async ({ variables }: QueryOptions) => {
    try {
      const request = { query, variables };
      const response = await ctx.client.post('/api/v1/ecommerce', request);
      return response.data;
    } catch (error:any) {
      splunkLogger({
        logType: 'error',
        data: { ...splunk_message?.ERROR?.GQL_COMMERCE_API_ERROR, error },
      });

      console.error('Error during API call:', error);
      return {error:[{msg:"unable to process the request"}]}
      //throw error; // Re-throw the error to propagate it to the caller if necessary
    }
  };
  return [postQuery];
};

export default function GQLProvider({ children }: { children: ReactNode }): JSX.Element {
  // const { config } = useConfig();
  // const client = axios.create({ baseURL: config?.services.kpvisionweb.url });
  // useAxiosLoader(client);
  const { ctproxyBffClient } = useServiceClients();
  const client = ctproxyBffClient
  return <GQLContext.Provider value={{ client }}>{children}</GQLContext.Provider>;
}
